import moment from 'moment';

class Schedule {
  constructor(
    fecha,
    horarioId,
    horario,
    segmId,
    segmento,
    diasegm,
    inicioDia,
    finDia,
    esFeriado,
    feriado,
    stPresen,
    stAusen,
    stIncon,
    stCaidas,
    stTarde,
    stRetant,
    stLicDias,
    stLicHoras,
    stExtras,
    horLabSum,
    horTrabSum,
    elementos,
    liqD,
    tarRet,
    regis
  ) {
    this.fecha = fecha;
    this.fechaTable =  moment.utc(fecha).format('DD-MM-YYYY');
    this.horarioId = horarioId;
    this.horario = horario;
    this.segmId = segmId;
    this.segmento = segmento;
    this.diasegm = diasegm;
    this.inicioDia = moment.utc(inicioDia).format('DD-MM-YYYY');
    this.finDia = moment.utc(finDia).format('DD-MM-YYYY');
    this.esFeriado = esFeriado === true ? '✔️' : "";;
    this.feriado = feriado;
    this.stPresen = stPresen === true ? '✔️' : "";
    this.stAusen = stAusen === true ? '✔️' : "";;
    this.stIncon = stIncon === true ? '✔️' : "";;
    this.stCaidas = stCaidas === true ? '✔️' : "";;
    this.stTarde = stTarde === true ? '✔️' : "";;
    this.stRetant = stRetant === true ? '✔️' : "";
    this.stLicDias = stLicDias === true ? '✔️' : "";;
    this.stLicHoras = stLicHoras === true ? '✔️' : "";;
    this.stExtras = stExtras === true ? '✔️' : "";;
    this.horLabSum = this.formatCantidad(horLabSum);
    this.horTrabSum = this.formatCantidad(horTrabSum);
    this.elementos = elementos;
    this.liqD = liqD;
    this.tarRet = tarRet;
    this.regis = regis;
  }
  static fromJson(data) {
    return new Schedule(
      data.fecha,
      data.horarioId,
      data.horario,
      data.segmId,
      data.segmento,
      data.diasegm,
      data.inicioDia,
      data.finDia,
      data.esFeriado,
      data.feriado,
      data.stPresen,
      data.stAusen,
      data.stIncon,
      data.stCaidas,
      data.stTarde,
      data.stRetant,
      data.stLicDias,
      data.stLicHoras,
      data.stExtras,
      data.horLabSum,
      data.horTrabSum,
      data.elementos,
      data.liqD,
      data.tarRet,
      data.regis
    );
  }
  formatCantidad(cantidad) {
    const horas = Math.floor(cantidad / 60);
    const minutos = cantidad % 60;
    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
  }
}

export default Schedule;
